import { useLanguage } from "@/i18n/LanguageContext";
const problems = [
  "Machines run, stop and slow down without reliable real-time reasons.",
  "Operators write reports manually after the shift.",
  "Supervisors see downtime too late.",
  "Planners do not know the real capacity of work centers.",
  "Maintenance reacts after failure, not before losses become expensive.",
  "Quality checks are disconnected from orders and batches.",
  "Materials move without full traceability.",
  "Energy is measured in total kWh, not by product, order or machine.",
  "Management sees yesterday's problem tomorrow.",
];

export default function ProblemGap() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border bg-[hsl(var(--section-alt))]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-8">
          <p className="eyebrow mb-3">{t("The gap")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t("Most factories lose profit because the real shop floor is invisible.")}</h2>
          <p className="text-muted-foreground">
            {t("ERP shows what should happen. The shop floor shows what really happens. In many factories, the gap between plan and reality is still managed with paper, Excel, phone calls and delayed reports.")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {problems.map((p) => (
            <div key={p} className="rounded-md border border-border bg-card/60 p-4 text-sm text-foreground/85">
              <span className="text-oee-red me-2">✕</span>{t(p)}
            </div>
          ))}
        </div>
        <p className="mt-8 text-lg text-foreground/90 max-w-3xl">
          <span className="text-primary font-semibold">{t("BEEDIGIT")}</span> {t("closes this gap by connecting the physical factory with digital execution.")}
        </p>
      </div>
    </section>
  );
}